import React from "react";
import { HAIRNET_ID } from "../../../../GlobalValues";
import ExtractorService from "common/services/Extractor";

const Hairnet = ({ merchant }) => {
  const hairnetUrl = merchant?.extended_data?.["extended_string_data_3"];
  const shoudDisplayIframe =
    merchant?.extended_data?.["extended_string_data_28"];
  const shouldDisplay = shoudDisplayIframe
    ? ExtractorService.extractBoolean(shoudDisplayIframe)
    : false;

  if (!hairnetUrl || !shouldDisplay) {
    return null;
  }

  return (
    <section
      id={HAIRNET_ID}
      aria-label="Réservation de prestations"
      style={{
        width: "100%",
        height: "600px",
        maxWidth: "100%",
        overflow: "hidden",
        display: "flex",
        contain: "layout",
      }}
    >
      <iframe
        src={hairnetUrl}
        title="Système de réservation de prestations du salon"
        loading="lazy"
        width="100%"
        height="600"
        style={{
          border: "none",
          width: "100%",
          height: "100%",
          minHeight: "300px",
          maxWidth: "100%",
          flex: 1,
        }}
        allowFullScreen
        aria-label="Réservez vos prestations en ligne"
      />
    </section>
  );
};

export default Hairnet;
